// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.merchant-phone-input-wrap {
  display: flex;
  width: 100%;
  min-height: var(--input-height);
  align-items: center;
  gap: var(--space-field);
  border: 1px solid #e8e9ec;
  border-radius: var(--radius-field);
  background-color: #f3f4f6;
  padding: 0 var(--space-field);
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.merchant-phone-input-wrap:focus-within {
  border-color: #056dff;
  box-shadow: 0 0 0 1px #056dff;
}

.merchant-phone-input-wrap--error {
  border-color: #ff4d4f;
}

.merchant-phone-input-wrap--error:focus-within {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 1px #ff4d4f;
}

.merchant-phone-input__prefix {
  flex-shrink: 0;
  font-size: var(--text-base);
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
}

.merchant-phone-input__native {
  min-width: 0;
  flex: 1;
  height: var(--input-height);
  border: none;
  background: transparent;
  font-size: var(--text-base);
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
  outline: none;
  cursor: pointer;
}

.merchant-phone-input__native::placeholder {
  color: #9ca3af;
}

.merchant-phone-input-wrap--profile {
  background-color: #ffffff;
  border-color: #e8e9ec;
}

.merchant-phone-input-wrap--readonly {
  background-color: #f3f4f6;
  border-color: #e8e9ec;
  pointer-events: none;
  cursor: default;
}

.merchant-phone-input-wrap--readonly:focus-within {
  border-color: #e8e9ec;
  box-shadow: none;
}

.merchant-phone-input-wrap--readonly .merchant-phone-input__prefix,
.merchant-phone-input-wrap--readonly .merchant-phone-input__native {
  color: #9ca3af;
  cursor: default;
}
@media (max-width: 1550px) {
  .merchant-phone-input__native,
  .merchant-phone-input-wrap {
    min-height: 38px;
    height: 38px;
    font-size: 14px !important;
  }
  .merchant-phone-input__native::placeholder,
  .merchant-phone-input__prefix {
    font-size: 14px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/merchant/authentication/components/PhoneNumberField.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC;EAClC,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf;;mBAEiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;AACA;EACE;;IAEE,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;EAC5B;EACA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".merchant-phone-input-wrap {\n  display: flex;\n  width: 100%;\n  min-height: var(--input-height);\n  align-items: center;\n  gap: var(--space-field);\n  border: 1px solid #e8e9ec;\n  border-radius: var(--radius-field);\n  background-color: #f3f4f6;\n  padding: 0 var(--space-field);\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.merchant-phone-input-wrap:focus-within {\n  border-color: #056dff;\n  box-shadow: 0 0 0 1px #056dff;\n}\n\n.merchant-phone-input-wrap--error {\n  border-color: #ff4d4f;\n}\n\n.merchant-phone-input-wrap--error:focus-within {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 1px #ff4d4f;\n}\n\n.merchant-phone-input__prefix {\n  flex-shrink: 0;\n  font-size: var(--text-base);\n  font-weight: 500;\n  line-height: 1.5;\n  color: #171717;\n}\n\n.merchant-phone-input__native {\n  min-width: 0;\n  flex: 1;\n  height: var(--input-height);\n  border: none;\n  background: transparent;\n  font-size: var(--text-base);\n  font-weight: 500;\n  line-height: 1.5;\n  color: #171717;\n  outline: none;\n  cursor: pointer;\n}\n\n.merchant-phone-input__native::placeholder {\n  color: #9ca3af;\n}\n\n.merchant-phone-input-wrap--profile {\n  background-color: #ffffff;\n  border-color: #e8e9ec;\n}\n\n.merchant-phone-input-wrap--readonly {\n  background-color: #f3f4f6;\n  border-color: #e8e9ec;\n  pointer-events: none;\n  cursor: default;\n}\n\n.merchant-phone-input-wrap--readonly:focus-within {\n  border-color: #e8e9ec;\n  box-shadow: none;\n}\n\n.merchant-phone-input-wrap--readonly .merchant-phone-input__prefix,\n.merchant-phone-input-wrap--readonly .merchant-phone-input__native {\n  color: #9ca3af;\n  cursor: default;\n}\n@media (max-width: 1550px) {\n  .merchant-phone-input__native,\n  .merchant-phone-input-wrap {\n    min-height: 38px;\n    height: 38px;\n    font-size: 14px !important;\n  }\n  .merchant-phone-input__native::placeholder,\n  .merchant-phone-input__prefix {\n    font-size: 14px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
